// javascript-obfuscator chess-grandmaster.min.js --output chess-grandmaster.min.js
export class GameConstants {

    public static VERSION = "0.4";
    
    public static DEVELOPMENT = false;
    public static VERBOSE = false;
    public static BOT_DEVELOPMENT = false;

    public static readonly SPONSOR_IZZYGAMES = "izzygames";
    public static readonly SPONSOR_LAGGED = "Lagged";
    public static readonly SPONSOR_YANDEX = "Yandex";
    public static readonly SPONSOR_KINAI = "KINAI";
    public static readonly SPONSOR_HUZ = "HUZ";
    public static readonly SPONSOR_NONE = "none";
    public static readonly GAME_DISTRIBUTION = "GAME DISTRIBUTION";
    public static readonly SPONSOR: string = GameConstants.GAME_DISTRIBUTION;
    
    public static GAME_WIDTH = 768;
    public static GAME_HEIGHT = 1024;

    public static SQUARE_WIDTH = 87.25;

    public static START_STATE = "SplashState";

    public static COMPUTER_ID = "computer";

    public static SOLVED = "solved";
    public static PLAYED = "played";
    public static UNSOLVED = "unsolved";

    public static RIGHT = "right";
    public static LEFT = "left";

    public static TWO_MOVES_PROBLEMS = "2 moves";
    public static THREE_MOVES_PROBLEMS = "3 moves";
    public static FOUR_MOVES_PROBLEMS = "4 moves";

    public static FEN_START = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 1 1";

    public static PLAYER_RESIGNED = "player resigned";
    public static ADVERSARY_RESIGNED = "adversary resigned";
    
    public static CASTLING_QUEEN = "O-O-O";
    public static CASTLING_KING = "O-O";

    public static COLUMNS = ["a", "b", "c", "d", "e", "f", "g", "h"];
    public static ROWS = ["8", "7", "6", "5", "4", "3", "2", "1"];

    public static DIFFICULTY_EASY = "EASY";
    public static DIFFICULTY_MEDIUM = "MEDIUM";
    public static DIFFICULTY_HARD = "HARD";

    public static WHITE = "w";
    public static BLACK = "b";
    public static DRAW = "0";

    public static BLACK_BISHOP = "b";
    public static BLACK_KING = "k";
    public static BLACK_KNIGHT = "n";
    public static BLACK_PAWN = "p";
    public static BLACK_QUEEN = "q";
    public static BLACK_ROOK = "r";

    public static WHITE_BISHOP = "B";
    public static WHITE_KING = "K";
    public static WHITE_KNIGHT = "N";
    public static WHITE_PAWN = "P";
    public static WHITE_QUEEN = "Q";
    public static WHITE_ROOK = "R";

    public static TEXT_COLOR_BLACK = "#111E37";
    public static TEXT_COLOR_WHITE = "#F6F9EF";

    public static RED_SQUARE = "red-square";
    public static GREEN_SQUARE = "green-square";
    public static OLIVE_GREEN_SQUARE = "olive-green-square";
    public static BLUE_SQUARE = "blue-square";
    public static WHITE_SQUARE = "white-square";
    public static GAME_WHITE_SQUARE = "game-white-square";
    public static BLACK_SQUARE = "black-square";
    public static GRAY_SQUARE = "gray-square";
    public static DARK_BLUE_SQUARE = "dark-blue-square";

    public static BITMAP_SIZE = 64;

    public static ALPHA_LAYERS = .25;

    public static TIME_FADE = 600;

    public static TIME_HINT = 30;
    public static MAX_HINTS = 5;

    public static AUDIO_SWITCH = "audio";
    public static TIMER_SWITCH = "timer";

    public static AFFILIATION_ACCEPTED = "accepted";
    public static AFFILIATION_INVITED = "invited";
    public static AFFILIATION_LEFT = "left";

    public static MESSAGE_TYPE_UPDATE = "update";
    public static MESSAGE_TYPE_BOT = "bot";
    public static MESSAGE_TYPE_MOVE = "move";
    public static MESSAGE_TYPE_AFFILIATION_CHANGE = "affiliation_change";
    public static MESSAGE_TYPE_OUTCOME = "outcome";

    public static MESSAGE_BOARD_CREATED = "board created";
    public static MESSAGE_BOARD_CREATED_BOT = "board created bot";
    
    public static GAME_DATA_KEY = "chess_game_data";

    public static STATS_KEY = "stats key";
    public static AUDIO_KEY = "audio key";
    public static TIMER_KEY = "timer key";
    public static ADVERSARY_CAPTURED_PIECES_KEY = "player captured pieces key";
    public static PLAYER_CAPTURED_PIECES_KEY = "adversary captured pieces key";
}
